// extracted by mini-css-extract-plugin
export default {"AdminDashboard":"Dashboard_AdminDashboard__G47B5"};